import AppRoutes from "./routes/AppRoutes";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

function App() {
  return <AppRoutes />;
}

export default App;